export default "__VITE_ASSET__Sp6gGSqn__"